import styled from 'styled-components';

import { ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';

export const StyledGroupHeaderOptions = styled.div`
    position: relative;
`;

export const OptionsButton = styled(ButtonIcon)`
    &&& {
        width: 40px;
        height: 40px;

        border-radius: 100px;
    }
`;
